export enum AccountType {
  PrivateDemand = "PrivateDemand",
  BusinessDemand = "BusinessDemand",
  PrivateSupply = "PrivateSupply",
  BusinessSupply = "BusinessSupply",
  ThreePLSupply = "ThreePLSupply"
}
